import * as tslib_1 from "tslib";
export var AutocompleteChange;
(function (AutocompleteChange) {
    AutocompleteChange["MouseUp"] = "MouseUp";
    AutocompleteChange["KeyArrowUp"] = "KeyArrowUp";
    AutocompleteChange["KeyArrowDown"] = "KeyArrowDown";
    AutocompleteChange["KeyEscape"] = "KeyEscape";
    AutocompleteChange["KeyHome"] = "KeyHome";
    AutocompleteChange["KeyEnd"] = "KeyEnd";
    AutocompleteChange["KeySpace"] = "KeySpace";
    AutocompleteChange["KeyEnter"] = "KeyEnter";
    AutocompleteChange["ItemMouseEnter"] = "ItemMouseEnter";
    AutocompleteChange["ItemClick"] = "ItemClick";
    AutocompleteChange["InputBlur"] = "InputBlur";
    AutocompleteChange["InputChange"] = "InputChange";
    AutocompleteChange["ButtonClick"] = "ButtonClick";
    AutocompleteChange["ButtonBlur"] = "ButtonBlur";
})(AutocompleteChange || (AutocompleteChange = {}));
export var autocompleteReducer = function (state, action, props) {
    var highlightedIndex = state.highlightedIndex;
    var reset = { selectedItem: null };
    switch (action.type) {
        case AutocompleteChange.ButtonClick:
            if (state.isOpen)
                return tslib_1.__assign({}, state, reset, { isOpen: false });
            return tslib_1.__assign({}, state, reset, { highlightedIndex: null, isOpen: true });
        case AutocompleteChange.KeyEscape:
        case AutocompleteChange.ButtonBlur:
        case AutocompleteChange.InputBlur:
        case AutocompleteChange.MouseUp:
            return tslib_1.__assign({}, state, reset, { isOpen: false });
        case AutocompleteChange.ItemClick:
        case AutocompleteChange.KeyEnter:
            return tslib_1.__assign({}, state, { isOpen: false, inputValue: props.itemToString(action.item), selectedItem: action.item });
        case AutocompleteChange.KeyArrowDown:
        case AutocompleteChange.KeyArrowUp:
            var next = (highlightedIndex === null ? -1 : highlightedIndex) + action.amount;
            if (next < 0 || next >= action.total)
                return state;
            return tslib_1.__assign({}, state, { highlightedIndex: next });
        case AutocompleteChange.ItemMouseEnter:
            return tslib_1.__assign({}, state, { highlightedIndex: action.index });
        case AutocompleteChange.InputChange:
            return tslib_1.__assign({}, state, reset, { highlightedIndex: null, isOpen: true, inputValue: action.value });
    }
};
var AutocompleteStore = /** @class */ (function () {
    function AutocompleteStore(reducer) {
        var _this = this;
        if (reducer === void 0) { reducer = autocompleteReducer; }
        this.highlightedIndex = null;
        this.inputValue = null;
        this.isOpen = false;
        this.selectedItem = null;
        this.dispatch = function (action, props) {
            return Object.assign(_this, _this.reducer(_this, action, props));
        };
        this.reducer = reducer;
    }
    return AutocompleteStore;
}());
export { AutocompleteStore };
